import { BreakOption } from '@types';
import { BulkShiftActionData } from 'api';
import { HqApiService } from './hqApiService';
import { ShiftBulkArchivePayload } from './shift-planning-service.types';

class ShiftService {
  constructor(private readonly hqApiService: HqApiService) {}

  public getBreakOptions = async () => {
    const response = await this.hqApiService.get<{ breakOptions: BreakOption[] }>({
      path: `shifts/get-break-options`,
    });

    return response;
  };

  public archiveShift = async (shiftId: string) => {
    return await this.hqApiService.update({
      path: `shifts/${shiftId}/archive`,
    });
  };

  public bulkArchiveShifts = async (
    data: ShiftBulkArchivePayload
  ): Promise<BulkShiftActionData> => {
    return await this.hqApiService.update({
      path: `shifts/bulk-archive`,
      body: data,
    });
  };
}

export { ShiftService };
